import React, { forwardRef } from 'react';
import InputSearch from '../InputSearch';

import * as S from './styles';

export type HealthPlanData = {
  insuranceName: string;
  plan: string;
  benefiarcyNumber: string;
};

type HealthPlanFormProps = {
  insuranceName: string;
  planName: string;
  onClickInput: (inputyType: 'healthInsurance' | 'healthPlan') => void;
};

const HealthPlanForm = forwardRef<any, HealthPlanFormProps>(({ insuranceName, planName, onClickInput }, ref: any) => {
  return (
    <S.Container ref={ref}>
      <S.Info>Informe os dados do convênio</S.Info>
      <S.FieldWrapper>
        <InputSearch
          testId="test-insurance-name"
          onChange={value => {}}
          handleChangeValue={value => {}}
          onFocus={value => {
            onClickInput('healthInsurance');
          }}
          placeholder="Convênio"
          label="Convênio"
          searchIcon={false}
          value={insuranceName}
          /* iconRight={<img src={ChevronImg} alt="chevron" />} */
        />
      </S.FieldWrapper>
      <S.FieldWrapper>
        <InputSearch
          testId="test-plan-name"
          onChange={value => {}}
          disabled={insuranceName?.length === 0}
          handleChangeValue={value => {}}
          onFocus={value => {
            onClickInput('healthPlan');
          }}
          placeholder="Plano"
          label="Plano"
          searchIcon={false}
          value={planName}
          /* iconRight={<img src={ChevronImg} alt="chevron" />} */
        />
      </S.FieldWrapper>
    </S.Container>
  );
});

export default HealthPlanForm;
